import React, { createContext, useContext, useEffect, useState } from "react";
import { translate } from "@/lib/i18n";

// ---- Theme ----
const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("gpai_theme") || "dark");
  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("gpai_theme", theme);
  }, [theme]);
  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return <ThemeContext.Provider value={{ theme, setTheme, toggle }}>{children}</ThemeContext.Provider>;
}

// ---- Locale ----
const LocaleContext = createContext(null);
export const useLocale = () => useContext(LocaleContext);

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => localStorage.getItem("gpai_locale") || "pt");
  const setLocale = (l) => { setLocaleState(l); localStorage.setItem("gpai_locale", l); };
  const t = (key) => translate(locale, key);
  return <LocaleContext.Provider value={{ locale, setLocale, t }}>{children}</LocaleContext.Provider>;
}

// ---- Currency ----
const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem("gpai_currency") || "BRL");
  const setCurrency = (c) => { setCurrencyState(c); localStorage.setItem("gpai_currency", c); };
  return <CurrencyContext.Provider value={{ currency, setCurrency }}>{children}</CurrencyContext.Provider>;
}
